// extracted by mini-css-extract-plugin
export default {"pagination":"TablePagination_pagination__lqooM","pageInfo":"TablePagination_pageInfo__Xcocf"};